module.exports = __webpack_public_path__ + "media/images/icon_favoritepoint-a3f4dffdf494041d2d0fbcc0e8688eee.svg";